<div
	(isOpened)="_opened = $event"
	[alarisDropdown]="contactsDropDown"
	[minDropdownWidth]="280"
	[positions]="positions"
	[class.opened]="_opened"
	class="select"
>
	{{ this.contacts.length }}
	<alaris-icon [class.opened]="_opened" class="arrow" name="icon-arrow-select"> </alaris-icon>
</div>

<alaris-dropdown #contactsDropDown [closeOnClick]="false">
	<div class="contacts">
		@for (contact of contacts.slice(0, maxVisibleContacts); let i = $index; track i) {
			<div class="contact">
				<span class="index">{{ i + 1 }}</span>
				@if (code) {
					+{{ code }}
				}
				{{ contact }}
			</div>
		}
	</div>
	@if (contacts.length > maxVisibleContacts) {
		<div class="preview-note">
			{{ 'campaigns.phonePreview' | translate: { amount: maxVisibleContacts } }}
		</div>
	}
</alaris-dropdown>
